import * as React from "react";
import { connect } from "react-redux";
import LoadingFullScreen from "../../../components/LoadingFullScreen";
import { RootDispatch, RootState } from "../../types";
import "./SigninContainer.scss";
import { signin } from "../actions";
import Signin from "../components/Signin";
import { User } from "../../session/types";
import { fetchCurrentUser } from "../../session/actions";

interface StoreProps {
  loading: boolean;
  token: string;
  errorMessage: string | null;
  user: User | null;
}

interface DispatchProps {
  signin: (username: string, password: string) => void;
  getUser: () => void;
}

interface OwnState {
  isBusy: boolean;
}

type Props = OwnState & DispatchProps & StoreProps;

class SigninContainer extends React.PureComponent<Props, OwnState> {
  public constructor(props: Props) {
    super(props);

    this.state = {
      isBusy: false
    };
  }

  public componentDidMount(): void {
    this.props.getUser();
  }

  public render() {
    const { loading, errorMessage } = this.props;
    return (
      <>
        {loading && <LoadingFullScreen />}
        <Signin signin={this.props.signin} errorMessage={errorMessage} />
      </>
    );
  }
}

export default connect(
  (state: RootState): StoreProps => ({
    user: state.session.data.currentUser,
    loading: state.signin.loading,
    token: state.signin.data.token,
    errorMessage: state.signin.errorMessage
  }),
  (dispatch: RootDispatch): DispatchProps => ({
    signin: (userame: string, password: string) => dispatch(signin(userame, password)),
    getUser: () => dispatch(fetchCurrentUser())
  })
)(SigninContainer);
